import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Ticket } from '../../../interfaces/tickets/Ticket';
import { ProductSale } from '../../../interfaces/tickets/ProductSale';

@Component({
  selector: 'ng-tickets-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss', '../../tickets/styles/ticket.scss']
})
export class ProductListComponent {

  @Input()
  productSale: ProductSale;

  @Input()
  productList: Ticket[];

  @Input()
  loading: boolean;

  @Output()
  nextStep = new EventEmitter();

  selectProduct(product) {
    this.productSale.ticketProduct = product;
  }

  isChecked(product) {
    return this.productSale.ticketProduct && this.productSale.ticketProduct.id === product.id;
  }

  changeTicketAmount(value: number) {
    this.productSale.ticketAmount += value;

    if (this.productSale.ticketAmount < 1) {
      this.productSale.ticketAmount = 1;
    }
  }

}
